/** Setup examples never contain a saved or newly-created token. */
export function mcpSetupExamples(endpoint: string, trustedApiOrigin: string) {
  const url = new URL(endpoint);
  if (!['https:', 'http:'].includes(url.protocol)) throw new Error('Unsupported MCP URL');
  const trusted = new URL(trustedApiOrigin);
  if (url.origin !== trusted.origin) throw new Error('Untrusted MCP origin');
  url.username = '';
  url.password = '';
  url.search = '';
  url.hash = '';
  const mcpUrl = url.toString();
  return {
    url: mcpUrl,
    codex: `[mcp_servers.proj_creator]\nurl = ${JSON.stringify(mcpUrl)}\nbearer_token_env_var = "PROJ_CREATOR_TOOL_TOKEN"\n`,
    claude: JSON.stringify({
      mcpServers: {
        proj_creator: {
          type: 'http',
          url: mcpUrl,
          headers: { Authorization: 'Bearer ${PROJ_CREATOR_TOOL_TOKEN}' }
        }
      }
    }, null, 2),
    // Single-quote the URL because paths can contain shell metacharacters.
    http: `curl --fail-with-body '${mcpUrl.replace(/'/g, "'\"'\"'")}' \\\n  -H 'Content-Type: application/json' \\\n  -H 'Accept: application/json, text/event-stream' \\\n  --data '{"jsonrpc":"2.0","id":1,"method":"initialize","params":{"protocolVersion":"2025-03-26","capabilities":{},"clientInfo":{"name":"setup-check","version":"1.0"}}}'`
  };
}
